import React from "react";
import { BaseBox, BaseContainer } from "../exports";
import BaseSidebar from "./BaseSidebar";
import BaseHeader from "./BaseHeader";
import BaseFooter from "./BaseFooter";

export default function BasePageLayout({
  children,
  sidebarItems = [],
  contentSx = {},
  containerSx = {},
  containerMaxWidth = "lg",
}) {
  const [sidebarOpen, setSidebarOpen] = React.useState(false);

  const toggleSidebar = () => setSidebarOpen((prev) => !prev);

  return (
    <BaseBox sx={{ display: "flex", minHeight: "100vh", flexDirection: "column" }}>
      {/* Header */}
      <BaseHeader onMenuClick={toggleSidebar} />

      {/* Main body */}
      <BaseBox sx={{ display: "flex", flex: 1 }}>
        {/* Sidebar */}
        <BaseSidebar items={sidebarItems} open={sidebarOpen} onToggle={toggleSidebar} />

        {/* Main content */}
        <BaseBox
          sx={{
            flex: 1,
            pt: 3, // padding-top instead of margin-top
            pb: 3,
            px: 2,
            backgroundColor: "#f9f9f9",
            transition: "margin-left 0.3s",
            ml: sidebarOpen ? "220px" : "50px",
            display: "flex",
            justifyContent: "center",
            ...contentSx,
          }}
        >
          <BaseContainer maxWidth={containerMaxWidth} sx={{ pt: 2, ...containerSx }}>
            {children}
          </BaseContainer>
        </BaseBox>
      </BaseBox>

      {/* Footer */}
      <BaseFooter />
    </BaseBox>
  );
}
